/**
 * Alle Routen werden mit Locale-Präfix gebaut (`/de?…`), weil `routing.localePrefix`
 * auf `always` steht und die Canonicals ebenfalls das Präfix tragen. Ohne Präfix
 * beantwortet die next-intl-Middleware jeden internen Link mit einem 307 auf die
 * Präfix-Variante — ein zusätzlicher Hop für Besucher wie für Crawler, und kein
 * interner Link würde auf die kanonische URL zeigen.
 */
type CompanySpecific = { locale: string; companyId?: string };
type PostSpecific = CompanySpecific & { id: string };

type RouteParams = {
  jobList: CompanySpecific;
  jobPost: PostSpecific;
  jobApplication: PostSpecific;
  jobApplicationSuccess: PostSpecific;
};

const withQuery = (locale: string, path: string, params: Record<string, string | undefined>): string => {
  const query = Object.entries(params)
    .filter((entry): entry is [string, string] => Boolean(entry[1]))
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return `/${locale}${path}${query ? `?${query}` : ''}`;
};

const ROUTES: { [K in keyof RouteParams]: (params: RouteParams[K]) => string } = {
  jobList: ({ locale, companyId }) => withQuery(locale, '', { companyId }),
  jobPost: ({ locale, companyId, id }) => withQuery(locale, '', { companyId, id }),
  jobApplication: ({ locale, companyId, id }) => withQuery(locale, '/apply', { companyId, id }),
  jobApplicationSuccess: ({ locale, companyId, id }) => withQuery(locale, '/apply/success', { companyId, id }),
};

export const resolveRoute = <K extends keyof RouteParams>(route: K, params: RouteParams[K]): string => {
  return ROUTES[route](params);
};
